/**
 * HistoryTable React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";

// Material-UI
import {withStyles} from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";

// icons
import EditIcon from '@material-ui/icons/Edit';
import UndoIcon from '@material-ui/icons/Undo';
import HelpIcon from '@material-ui/icons/Help';

// application
import {toUserFriendlyDateTimeString} from "../../utils";


/**
 * HistoryTable shows object changes
 *
 * @author Jens Gruschel
 */
export class HistoryTable extends React.Component {

    render() {

        return <Table>
            <TableHead>
                <TableRow>
                    {this.props.includeObjectInfo && <TableCell>Typ</TableCell>}
                    {this.props.includeObjectInfo && <TableCell>Titel</TableCell>}
                    <TableCell>Zeitpunkt</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Änderungen</TableCell>
                    <TableCell align="right">Aktionen</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    this.props.changes.map(change => this.renderChange(change))
                }
            </TableBody>
        </Table>;
    }

    renderChange(change) {

        const time = toUserFriendlyDateTimeString(new Date(change.time));
        const typeId = change.previousObject.type;
        const typeDefinition = this.props.typeDefinitions[typeId] || {}
        const iconurl = typeDefinition ? typeDefinition.fields.iconurl : undefined;
        const typeName = typeDefinition ? typeDefinition.fields.name || typeId : typeId;

        return <TableRow key={change.id + "/" + change.time}>
            {this.props.includeObjectInfo && <TableCell><Tooltip title={typeName}>{
                iconurl ? <img
                    className={this.props.classes.iconImage}
                    src={iconurl}
                    alt={typeName}
                    width={24}
                    height={24}
                /> : <HelpIcon/>
            }</Tooltip></TableCell>}
            {this.props.includeObjectInfo && <TableCell>{change.previousObject.title}</TableCell>}
            <TableCell>{time}</TableCell>
            <TableCell>{change.user}</TableCell>
            <TableCell>{this.renderChangeItems(change.items)}</TableCell>
            <TableCell align="right">
                {this.props.onEdit && <Tooltip title={"aktuelles Objekt bearbeiten"}>
                    <IconButton
                        onClick={() => this.props.onEdit(change.id)}
                    >
                        <EditIcon/>
                    </IconButton>
                </Tooltip>}
                {this.props.onUndo && <Tooltip title={"diese und alle nachfolgenden Änderungen zurücknehmen"}>
                    <IconButton
                        onClick={() => this.props.onUndo(change.previousObject)}
                    >
                        <UndoIcon/>
                    </IconButton>
                </Tooltip>}
            </TableCell>
        </TableRow>;
    }

    renderChangeItems(items) {

        if (!items) return undefined;

        return <div style={{overflowWrap: "anywhere"}}>
            {
                items.map(item => <Tooltip key={item.key} title={item.description}>
                    <span className={item.isField ? this.props.classes.fieldBox : this.props.classes.valueBox}>
                        <label className={item.isField ? this.props.classes.fieldLabel : this.props.classes.valueLabel}>{item.name || "etc."}</label>
                    </span>
                </Tooltip>)
            }
        </div>;
    }
}

const styles = theme => ({
    fieldBox: {
        position: "relative",
        top: "4px",
        margin: "8px 4px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderRadius: "4px",
        borderColor: "rgba(0, 0, 0, 0.23)"
    },
    valueBox: {
        position: "relative",
        top: "4px",
        margin: "8px 4px",
        borderStyle: "solid",
        borderWidth: "1px",
        borderRadius: "4px",
        borderColor: "rgba(0, 0, 0, 0.23)"
    },
    fieldLabel: {
        position: "relative",
        top: "-8px",
        margin: "0px 5px",
        padding: "0px 3px",
        color: theme.palette.primary.main,
        backgroundColor: "#fff",
        whiteSpace: "nowrap"
    },
    valueLabel: {
        position: "relative",
        top: "-8px",
        margin: "0px 5px",
        padding: "0px 3px",
        color: "#777",
        backgroundColor: "#fff",
        whiteSpace: "nowrap"
    },
    iconImage: {
        opacity: 0.75
    }
});

HistoryTable.propTypes = {
    includeObjectInfo: PropTypes.bool,
    changes: PropTypes.array.isRequired,
    onEdit: PropTypes.func,
    onUndo: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        typeDefinitions: state.types.typeDefinitions
    };
}

export default connect(mapStateToProps)(withStyles(styles)(HistoryTable));